import { isNumber } from "lodash";
import { collectAllMeasures, getMutableComponentProps, removeMeasures } from "./utils";
import { DatapointBenchmarkTypeEnum } from "api/ux/src";
const editColDefHeader = (columns, id, label) => {
    for (const column of columns) {
        const col = column, group = column;
        if (col.field === id || group.groupId === id) {
            col.headerName = label;
            return true;
        }
        else if (group?.children && editColDefHeader(group.children, id, label)) {
            return true;
        }
    }
    return false;
};
const updateBenchmarkLabel = (measures, id, label) => {
    if (label) {
        const measure = measures?.find((x) => x.name === id);
        if (measure) {
            measure.label = label;
        }
    }
};
const updateVisitorHeatMapParams = (measures, id, label) => {
    if (label) {
        const measure = measures?.find((x) => x.name === id);
        if (measure) {
            measure.label = label;
            measure.dimensionValue = label;
        }
    }
};
const editDatapointsRequest = (measures, id, index) => {
    for (const measure of measures) {
        if (measure.name === id) {
            measure.benchmark = {
                id: index ?? "none",
                type: DatapointBenchmarkTypeEnum.Publicbenchmark
            };
        }
    }
};
export const setupPublicIndicesContext = (componentProps, allDependencies, originalComponentProps, argument) => {
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    const measures = collectAllMeasures(mutableComponentProps), stackedColumnCharts = mutableComponentProps.pipelineParameter?.customVisitorsReducer?.filter((x) => x.method === "stackedColumnChart");
    for (const [id, index] of Object.entries(argument || {})) {
        const i = parseInt(index, 10);
        if (isNumber(i)) {
            const pref = allDependencies.pmiPreferences?.[i - 1], switcher = mutableComponentProps?.gridSwitcher;
            if (mutableComponentProps.columnsTemplate?.columns) {
                editColDefHeader(mutableComponentProps.columnsTemplate.columns, id, pref?.label ?? "-");
            }
            if (switcher?.columnsTemplate?.columns) {
                editColDefHeader(switcher.columnsTemplate.columns, id, pref?.label ?? "-");
            }
            if (measures.length) {
                editDatapointsRequest(measures, id, pref?.id);
            }
            stackedColumnCharts?.forEach((x) => updateBenchmarkLabel(x.arguments?.[0]?.measures, id, pref?.label));
        }
    }
    removeMeasures(mutableComponentProps, (m) => m.benchmark?.type === DatapointBenchmarkTypeEnum.Publicbenchmark && m.benchmark?.id === "none");
    return mutableComponentProps;
};
const updateVisitorArgumets = (id, generic, i, visitorHeatMap, stackedColumnCharts, filterByDatapointVisitor) => {
    visitorHeatMap?.forEach((x) => updateVisitorHeatMapParams(x.arguments?.[0]?.axisValues, id, generic?.name));
    stackedColumnCharts?.forEach((x) => updateBenchmarkLabel(x.arguments?.[0]?.measures, id, generic?.name));
    filterByDatapointVisitor?.forEach((x) => {
        if (x.arguments?.[1]?.[i - 1]) {
            x.arguments[1][i] = generic?.name;
        }
    });
};
export const setupGenericIndicesContext = (componentProps, allDependencies, originalComponentProps, argument) => {
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    const filterByDatapointVisitor = mutableComponentProps.pipelineParameter?.datapointsVisitorsReducer?.filter((x) => x.method === "filterByDatapoint"), measures = collectAllMeasures(mutableComponentProps), stackedColumnCharts = mutableComponentProps.pipelineParameter?.customVisitorsReducer?.filter((x) => x.method === "stackedColumnChart"), visitorHeatMap = mutableComponentProps.pipelineParameter?.customVisitorsReducer?.filter((x) => x.method === "heatMap");
    for (const [id, index] of Object.entries(argument || {})) {
        const i = parseInt(index, 10);
        if (isNumber(i)) {
            const generic = Object.values(allDependencies.genericIndices)?.[i - 1], switcher = mutableComponentProps?.gridSwitcher;
            if (mutableComponentProps.columnsTemplate?.columns) {
                editColDefHeader(mutableComponentProps.columnsTemplate.columns, id, generic?.name ?? "-");
            }
            if (switcher?.columnsTemplate?.columns) {
                editColDefHeader(switcher.columnsTemplate.columns, id, generic?.name ?? "-");
            }
            if (measures.length) {
                editDatapointsRequest(measures, id, generic?.benchmarkId);
            }
            updateVisitorArgumets(id, generic, i, visitorHeatMap, stackedColumnCharts, filterByDatapointVisitor);
        }
    }
    return mutableComponentProps;
};
